import { HttpContextToken } from "@angular/common/http";

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
export const SHOW_LOADER = new HttpContextToken<boolean>(() => false);
export const LOADER_SECTION = new HttpContextToken<string | null>(() => null);
export const USE_SESSION_TOKEN = new HttpContextToken<boolean>(() => false);
export const SKIP_ERROR_HANDLER = new HttpContextToken<boolean>(() => false);